import SideMenu from "./SideMenu.component.jsx";

export default SideMenu;